import axios from 'axios';

const cors = require('cors');


// export function locationPageData() {


//     return new Promise((resolve,reject)=>{

//         axios.get('https://spiritual-grin-332609.el.r.appspot.com/blc-location').then(response=>{

//         resolve(response.data);
//         });
//     });
// }




export function blcfacilitypagedata() {


    return new Promise((resolve, reject) => {

        // axios.get('http://localhost:1337/blc-pricing',cors()).then(response=>{

        // resolve(response.data);
        axios.get('https://blcadmin.brac.net/api/blc-pricing', cors()).then(response => {

            resolve(response.data);
        })
    })
}


// http://localhost:1337/blc-pricing

// http://34.123.182.161/blc-facilities
 //https://blcadmin.brac.net/blc-pricing